module.exports = __webpack_public_path__ + "static/img/xbq0610.883e13a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xbq0610.jpg
// module id = RGjv
// module chunks = 0